import Banner from '@/components/Banner/Banner';
import { useMessage } from '@/messages';

export const ProductInfoGuide = () => {
  const m = useMessage();

  return (
    <Banner
      title={m.scraping('PRODUCT_INFO_GUIDE_TITLE')}
      desc={m.scraping('PRODUCT_INFO_GUIDE_DESC')}
      icon={null}
      flow="vertical"
    />
  );
};
